<template>
  <div class="agenda-speakers-wrapper">
    <div>
      <div class="agenda-speakers">
        <carousel
          navigationNextLabel='<i class="fa-solid fa-arrow-right" style="font-size: 10px;"></i>'
          navigationPrevLabel='<i class="fa-solid fa-arrow-left" style="font-size: 10px;"></i>'
          perPage="2"
          :navigationEnabled="false"
          :perPageCustom="perPageCustom"
        >
          <slide
            data-index="0"
            data-name=""
            v-for="(presenter, index) in presenters"
            :key="index"
          >
            <div>
              <speaker-short-card
                :name="presenter.name"
                :title="presenter.title"
                :photo="presenter.photo_url"
                @click.native="onOpenSpeakerModal(presenter)"
              />
            </div>
          </slide>
        </carousel>
      </div>
    </div>

    <speaker-modal
      v-if="showSpeakerModal"
      :showModal.sync="showSpeakerModal"
      :speaker="selectedSpeaker"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import SpeakerShortCard from "../SpeakerShortCard";
import SpeakerModal from '../../../views/agenda/common/speaker-modal.vue'

export default {
  props: [
    "presenters",
    'perPageCustom'
  ],
  components: {
    SpeakerModal,
    Carousel,
    Slide,
    SpeakerShortCard,
  },
  data() {
    return {
      settings: {},
      showScrollIcon: false,
      showSpeakerModal: false,
      selectedSpeaker: {},
    };
  },
  methods: {
    onOpenSpeakerModal(speaker) {
      this.selectedSpeaker = speaker;
      this.showSpeakerModal = true;
    }
  }
};
</script>

<style lang="scss">


//.VueCarousel-navigation-button{
//  top: calc(50% - 30px) !important;
//}
// paginationActiveColor="var(--attendee-brand-color)"
.VueCarousel-navigation-button, .VueCarousel-dot{
  &:focus{
    outline: none !important;
  }
}

.VueCarousel-dot-container{
  margin-top: 0 !important;
}

.VueCarousel-dot{
  margin-top: 0 !important;
  padding: 2px 10px !important;
}


.agenda-speakers-wrapper {
  //padding: 0 26px;

  li {
    list-style: none;
  }

}

.agenda-speakers {
  padding: 0 0 var(--attendee-gap-md) 0;
  //max-width: 100%;
  //width: auto;
}
</style>
